import React, { useRef } from "react";
import config from "../../../contexts/ConfigContext";
import { CommonLibrary } from "../../../contexts/CommonContext";
import { Row, Col } from "react-bootstrap";
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import {
  GridColumnMenuProps,
  GridColumnMenuFilter  
} from "@progress/kendo-react-grid";
import { ODataProvider } from "../../../contexts/ODataContext";
import { EntityService } from "../../../services/EntityService";
import DataGridCustom, { ColumnCustomProps, DataGridHandle } from "../../../components/DataGridCustom";
import { Link, useLocation } from "react-router-dom";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import { Button } from "@progress/kendo-react-buttons";
import Modal from 'react-bootstrap/Modal';

const ManageEntity: React.FC = () => {

  const entityService = new EntityService();
  const commonLibrary = new CommonLibrary();
  const { t } = useTranslation();
  const location = useLocation();
  const { EntityId, Description } = location.state as any;
  const labelApiUrl = config.API_URL + "/odata/ProjectLabels/";
  const labelEntityApiUrl = config.API_URL + "/odata/ProjectEntityLabels/";
  const dataGridLabelRef = useRef<DataGridHandle>(null);
  const dataGridLabelEntityRef = useRef<DataGridHandle>(null);
  const [selectedLabelItems, setSelectedLabelItems] = React.useState<number[]>([]);
  const [selectedLabelEntityItems, setSelectedLabelEntityItems] = React.useState<number[]>([]);
  const [show, setShow] = React.useState(false);

  const handleClose = () => setShow(false);

  // Define the column menu
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };
  // Define the columns

  const columnsLabel = [] as ColumnCustomProps[];
  columnsLabel.push({ field: "Description", title: t("general.name"), columnMenu: ColumnMenu, isExportable: true });
  columnsLabel.push({ field: "ParentDescription", title: t("general.parent"), columnMenu: ColumnMenu, isExportable: true });
  columnsLabel.push({ field: "Path", title: t("configuration.labels.path"), columnMenu: ColumnMenu, isExportable: true });
  columnsLabel.push({ field: "Tags", title: t("general.tags"), columnMenu: undefined, isExportable: true });

  const columnsEntityLabels = [] as ColumnCustomProps[];
  columnsEntityLabels.push({ field: "LabelDescription", title: t("general.name"), columnMenu: ColumnMenu, isExportable: true });
  columnsEntityLabels.push({ field: "LabelTags", title: t("general.tags"), columnMenu: undefined, isExportable: true });

  // Define handles
  const onSelectedItemsChangeLabel = (selectedItems: number[]) => {
    setSelectedLabelItems(selectedItems);
  }

  const onSelectedItemsChangeLabelEntity = (selectedItems: number[]) => {
    setSelectedLabelEntityItems(selectedItems);
  }

  React.useEffect(() => {


    dataGridLabelEntityRef.current?.filterData({
      logic: "and",
      filters: [
        {
          field: "EntityId",
          operator: "eq",
          value: EntityId
        }
      ]
    });
  }, []);

  const handleAddLabelsToEntity = () => {
    if (selectedLabelItems.length > 0) {
      const entityModel = {
        ProjectId: commonLibrary.ProjectId,
        TargetId: EntityId,
        ObjectIds: selectedLabelItems
      };
      entityService.AddLabelsToEntities(entityModel).then(() => {
        dataGridLabelEntityRef.current?.refreshData();
      });
    }
  }

  const handleRemoveLabelsFromEntity = () => {
    if (selectedLabelEntityItems.length > 0) {
      setShow(true);
    }
  }

  const handleConfirm = () => {
    setShow(false);
    const entityModel = {
      ProjectId: commonLibrary.ProjectId,
      TargetId: EntityId,
      ObjectIds: selectedLabelEntityItems
    };
    entityService.RemoveLabelsFromEntities(entityModel).then(() => {
      dataGridLabelEntityRef.current?.refreshData();
    });
  }


  return (
    <div>
      <Row className="pt-2">
        <Col sm={{ span: 2, offset: 10 }}>
          <Link className="btn" to="/entities">
             <SvgIcon className="btn-icons" icon={svgIcons.arrowLeftIcon} size="medium" /><Trans>general.returnToBack</Trans></Link>
        </Col>
      </Row>
      <div className="pt-2">
        <div className="tile-content">         
            <h5 className="title"><Trans>configuration.entities.manageLabelsTo</Trans> {Description}</h5>
            <span className="subtitle"><Trans>configuration.entities.subtitle</Trans></span>
          <Row className="pt-2">
            <Col sm={12}>             
              <ODataProvider baseUrl={labelApiUrl} loadingContent=".content-labels .k-grid-content">
                <DataGridCustom ref={dataGridLabelRef} DataItemKey="LabelId" Columns={columnsLabel} onSelectedItemsChange={onSelectedItemsChangeLabel} PageSize={6} />
              </ODataProvider>
            </Col>
          </Row>
        </div>
      </div>
      <div className="pt-4">
        <div className="tile-content">      
      <Row className="content-entity-labels">
        <Col sm={12}>
          <ODataProvider baseUrl={labelEntityApiUrl} loadingContent=".content-entity-labels .k-grid-content">
            <DataGridCustom PermissionButtonCode="configuration_entities_labels" ShowAddButton={true} ShowRemoveButton={true} onAddButtonClick={handleAddLabelsToEntity} onRemoveButtonClick={handleRemoveLabelsFromEntity} ref={dataGridLabelEntityRef} DataItemKey="LabelId" Columns={columnsEntityLabels} onSelectedItemsChange={onSelectedItemsChangeLabelEntity} PageSize={6} />
          </ODataProvider>
        </Col>
      </Row>
      </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title><Trans>general.titleRemoveMessage</Trans></Modal.Title>
        </Modal.Header>
        <Modal.Body><Trans>general.removeMessage</Trans></Modal.Body>
        <Modal.Footer>
          <Button themeColor="secondary" onClick={handleClose}>
            <Trans>general.cancel</Trans>
          </Button>
          <Button themeColor="primary" onClick={handleConfirm}>
            <Trans>general.ok</Trans>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ManageEntity;
